module.exports = __webpack_public_path__ + "static/media/shagi_white_bg.c667465a.jpg";